import React, { useMemo } from 'react';
import moment from 'moment';
import { humanize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import { sluggify } from '../../../utils/localization/utils';
import { AUTOMATED_PAYMENT_EVENTS } from 'constants/accounting';
import { Table, TableHeader, TableHead, TableRow, TableBody, TableCell, } from '@cargomatic/ui';
const Description = ({ ev }) => {
    var _a, _b;
    const { t } = useTranslation();
    if (ev.data && ev.data.human && ev.user) {
        return (React.createElement(React.Fragment, null, t('ACCOUNTING_AUDIT_EVENT', {
            event: ev.type && ev.type === 'rpa-update'
                ? ev.event
                : t(sluggify(humanize(ev.event))),
            user: ev.user,
        })));
    }
    if (AUTOMATED_PAYMENT_EVENTS.includes(ev.event) &&
        ((_a = ev === null || ev === void 0 ? void 0 : ev.data) === null || _a === void 0 ? void 0 : _a.automated_payment_status_event)) {
        return (React.createElement(React.Fragment, null,
            t(sluggify(ev.event)),
            React.createElement("div", { "data-testid": "div-8a1b6c65" }, `${t('AMOUNT')}: ${(_b = ev === null || ev === void 0 ? void 0 : ev.data) === null || _b === void 0 ? void 0 : _b.amount}`)));
    }
    return (React.createElement(React.Fragment, null, ev.type && ev.type === 'rpa-update'
        ? ev.event
        : t(sluggify(humanize(ev.event)))));
};
const HistoryTable = ({ data: events = [], type }) => {
    const { t } = useTranslation();
    if (events.length === 0) {
        return (React.createElement("p", { "data-testid": "h5-ee121e38", className: "py-3 my-0 text-sm text-muted-foreground" }, t('NO_EVENTS_RECORDED', { type })));
    }
    const reversedEvents = useMemo(() => [...events].reverse(), [events]);
    const history = reversedEvents.map((ev, index) => (React.createElement(TableRow, { "data-testid": `tr-67b9bad1-${index}`, key: ev._id },
        React.createElement(TableCell, { "data-testid": `td-e3fd6831-${index}` },
            React.createElement(Description, { ev: ev })),
        React.createElement(TableCell, { "data-testid": `td-ba7ed5ce-${index}` }, ev.user || t('UNKNOWN_USER')),
        React.createElement(TableCell, { "data-testid": `td-a811adfb-${index}` }, moment(ev.timestamp).format('LLLL')))));
    return (React.createElement("div", { "data-testid": "div-954cad61", className: "overflow-x-auto" },
        React.createElement(Table, { "data-testid": "table-8b2e37d2" },
            React.createElement(TableHeader, { "data-testid": "thead-f0114464" },
                React.createElement(TableRow, { "data-testid": "tr-7680c5bb" },
                    React.createElement(TableHead, { "data-testid": "th-971a159e" }, t('EVENT', { count: 1 })),
                    React.createElement(TableHead, { "data-testid": "th-4b7456fd" }, t('TRIGGERED_BY')),
                    React.createElement(TableHead, { "data-testid": "th-279e32a3" }, t('TIME')))),
            React.createElement(TableBody, { "data-testid": "tbody-e9cadd88" }, history))));
};
export default HistoryTable;
